<button id="{{referenceId}}" class="se-menu-reference">
  <span class="se-menu-reference__content">
    <ng-content></ng-content>
  </span>
</button>
